import React from 'react'
import { useUser } from '../../../context/userContext'
import { SaudiRiyalIcon } from '../../../shared/utils/icons'

const CurrencyIcon = () => {
  const { user } = useUser()

  return user?.company.currency === 'SAR' ? <SaudiRiyalIcon /> : user?.company.currency || '$'
}

export default CurrencyIcon
